<script context="module" lang="ts">
    import { z } from 'zod';

    export const MenuNotificationSchema = z.object({
        reload: z.boolean().optional(),
        type: z.enum(['none', 'warning', 'error', 'info']).optional(),
        text: z.string().optional(),
        showAuto: z.boolean().optional(),
        priority: z.number().optional()
    });

    export type MenuNotificationType = z.infer<typeof MenuNotificationSchema>;
</script>

<script lang="ts">
    import { tooltip } from '@svelte-plugins/tooltips';
    import ErrorColor from "../ErrorColor.svelte";
    import WarningColor from "../WarningColor.svelte";
    import InfoColor from '../InfoColor.svelte';

    export let id: string;
    export let notification: MenuNotificationType;
    export let currentPage: boolean = false;

    let styleComponent: any;
    let autoVisibility: boolean = false;

    let showWithTooltip: boolean = false;
    let oldText: string = '';
    let oldType: string = '';
    let oldAutoVisibility: boolean = false;
    let storageTimeout: any;

    $: {
        styleComponent = null;
        if (notification.text) {
            switch (notification.type) {
                case 'warning':
                    styleComponent = WarningColor;
                    break;
                case 'error':
                    styleComponent = ErrorColor;
                    break;
                case 'info':
                    styleComponent = InfoColor;
                    break;
            }
            if (!autoVisibility && oldAutoVisibility && storageTimeout) {
                clearTimeout(storageTimeout);
                storageTimeout = null;
            }
            autoVisibility = !!notification.showAuto && !currentPage;
            if (autoVisibility && !oldAutoVisibility) {
                let storageKey = 'MainMenuNotification:'+id;
                let storage = sessionStorage.getItem(storageKey);
                if (storage) {
                    console.log('MainMenuVerticalNotification, autoVisibility, session', id);
                    autoVisibility = false;
                } else {
                    storage = localStorage.getItem(storageKey);
                    if (storage && parseInt(storage) > 3) {
                        console.log('MainMenuVerticalNotification, autoVisibility, limit', id);
                        autoVisibility = false;
                    } else if (!storageTimeout) {
                        storageTimeout = setTimeout(() => {
                            console.log('MainMenuVerticalNotification, autoVisibility, storage');
                            sessionStorage.setItem(storageKey, '1');
                            localStorage.setItem(storageKey, storage ? (parseInt(storage)+1).toString() : '1');
                        }, 5000);
                    }
                }
            }
            if (autoVisibility != oldAutoVisibility || notification.text != oldText || notification.type != oldType) {
                console.log('MainMenuVerticalNotification', id, autoVisibility);
                showWithTooltip = false;
                setTimeout(() => showWithTooltip = true, 0);
            } else {
                showWithTooltip = true;
            }
            oldText = notification.text || '';
            oldType = notification.type || '';
            oldAutoVisibility = autoVisibility;
        }
    }
</script>

{#if styleComponent}
    {#if showWithTooltip}
        <div class="notification {notification.type}" use:tooltip={{content: notification.text, position: 'right', theme: 'lastmile-'+notification.type+'-tooltip', show: autoVisibility === true, maxWidth: 400}}>
            <svelte:component this={styleComponent}>
                <div class="dot"></div>
            </svelte:component>
        </div>
    {:else}
        <div class="notification">
            <svelte:component this={styleComponent}>
                <div class="dot"></div>
            </svelte:component>
        </div>
    {/if}
{/if}

<style>
    .notification {
        position: absolute;
        right: 4px;
        top: 4px;
    }
    .dot {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: #999;
    }
    :global(.tooltip.lastmile-error-tooltip) {
        --tooltip-z-index: 500;
        --tooltip-color: #ffffff;
        --tooltip-background-color: var(--automapa-red);
    }
    :global(.tooltip.lastmile-warning-tooltip) {
        --tooltip-z-index: 500;
        --tooltip-color: #ffffff;
        --tooltip-background-color: var(--automapa-orange);
    }
    :global(.tooltip.lastmile-info-tooltip) {
        --tooltip-z-index: 500;
        --tooltip-color: #ffffff;
        --tooltip-background-color: var(--automapa-blue);
    }
</style>